import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router";
import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs";
import { useLocation } from "react-router-dom";
import {
  setIsMergePopupActive,
  setOptAndSubmitContentResponse,
  setStreamVideoResponse,
} from "../../../store/publicStore/actions/utilsActions/utilsActions";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../common/Footer/Footer";
import { useToast } from "../../../../src/hooks/useToast";
import { getOptedCampaignsDetailsByInfluencer } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getOptedCampaignsDetailsByInfluencerActions";
import moment from "moment/moment";
import { optUGCCampaign } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/optUGCCampaignAction";
import { viewUGCContentforInfluencer } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/viewUGCContentforInfluencerAction";
import { optAndSubmitContentLink } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/optAndSubmitContentLinkActions";
import { optAndSubmitContent } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/optAndSubmitContentActions";
import { GiSandsOfTime } from "react-icons/gi";
import { FaCircleExclamation, FaCircleCheck } from "react-icons/fa6";
import { BsCollectionPlayFill } from "react-icons/bs";
import { IoIosCheckmarkCircle, IoIosCloseCircle } from "react-icons/io";
import Popup from "../../popups/Popup/Popup";
import { downloadContentForManualUpload } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/downloadContentForManualUploadActions";
import { publishVideoOnYoutube } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/publishVideoOnYoutubeAction";
import { SiLibreofficewriter } from "react-icons/si";
import { MyCampaignsImg } from "../../../static/constant/imgConstants";
import { Oval } from "react-loader-spinner";
import { isTodayOrFuture, isPastDate } from "../../../utils/date";
import {
  getCampaignListWithFilter
} from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getCampaignListFilterActions";
import { downloadReferenceVideo } from "../../../store/campaignStore/actions/CreateCampaignActions/downloadReferenceVideoActions";

const CampaignsDetails = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { campId } = useParams();
  const dispatch = useDispatch();
  const Toast = useToast();

  const [formValues, setFormValues] = useState({
    campaignId: "",
    name: "",
    purpose: "",
    platform: "",
    campaignType: "",
    startDate: "",
    endDate: "",
    script: "",
    dialogue: "",
    backgroundColor: "",
    otherProperties: "",
    mediaFileLink: "",
    isLocationRequired: false,
    uploadDuration: "",
    status: "",
  });

  const [isChecked, setIsChecked] = useState(false);
  const [ugcSuccessPopup, setUgcSuccessPopup] = useState();
  const [submitVideoIdPopup, setSubmitVideoIdPopup] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [videoIdError, setVideoIdError] = useState("");
  const errorTimeoutRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailurePopup, setShowFailurePopup] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [showBgcConfirmPopup, setShowBgcConfirmPopup] = useState(false);
  const [isBgcSubmitting, setIsBgcSubmitting] = useState(false);
  const [showBgcReadOnlyConfirmPopup, setShowBgcReadOnlyConfirmPopup] = useState(false);
  const [isBgcReadOnlySubmitting, setIsBgcReadOnlySubmitting] = useState(false);
  const [isPublishPopupOpen, setIsPublishPopupOpen] = useState(false);
  const [loadingPublish, setLoadingPublish] = useState(false);
  const [selectedKids, setSelectedKids] = useState(false);
  const [optResponse, setOptResponse] = useState(null);
  const [scheduleTime, setScheduleTime] = useState("");
  const [isScheduleMode, setIsScheduleMode] = useState(false);
  const [isDownloadingReferenceVideo, setIsDownloadingReferenceVideo] = useState(false);

  const optUGCCampaignReducer = useSelector(
    (state) => state.optUGCCampaignReducer
  );

  const getCampaignListFilterData = useSelector(
    (state) => state.getCampaignListFilterReducer.data
  );

  const getUserInfoReducerData = useSelector(
    (state) => state.getUserInfoReducer.data
  );

  const sanitizeStatus = (input) => {
    const statusMap = {
      VIDEO_ID_LAMBDA_VERIFICATION_FAILED: "VIDEO ID VERIFICATION FAILED",
      VIDEO_ID_LAMBDA_VERIFICATION_SUCCESS: "VIDEO ID VERIFIED",
      BUDGET_RELEASED_ADMIN_VIDEO_ID_VERIFICATION_FAILED: "BUDGET_RELEASED_ADMIN_VIDEO_ID_VERIFICATION_FAILED"
    };

    const sanitized = String(input).trim().toUpperCase();
    if (statusMap.hasOwnProperty(sanitized)) {
      return statusMap[sanitized];
    }
    return input;
  }

  const platformBasedAccess = formValues?.platform === "YOUTUBE" ? getUserInfoReducerData?.channelAccessType === "READ_ONLY" : formValues.platform === "INSTAGRAM" ? getUserInfoReducerData?.channelAccessTypeInstagram === "READ_ONLY" : false

  // BGC access type helpers
  const bgcChannelAccessType = formValues?.platform === "INSTAGRAM"
    ? getUserInfoReducerData?.channelAccessTypeInstagram
    : getUserInfoReducerData?.channelAccessType;
  const isBgcFullAccess = formValues?.campaignType === "BGC" && bgcChannelAccessType === "FULL_ACCESS";
  const isBgcReadOnly = formValues?.campaignType === "BGC" && bgcChannelAccessType === "READ_ONLY";
  const platformDisplayName = formValues?.platform === "INSTAGRAM" ? "Instagram" : "YouTube";

  const isButtonVisible = (() => {
    // BGC: buttons visible immediately (no status gate/access check needed)
    if (!isBgcReadOnly) {
      if (formValues?.status !== "OPTED") return false;
      if (!platformBasedAccess) return false;
    }
    if (formValues.campaignType === "UGC") return false;

    // Excluded upload statuses
    const excludedStatuses = [
      "MERGE_FAILED",
      "PUBLISHED",
      "EXPIRED",
      "BUDGET_RELEASED_ADMIN_VIDEO_ID_VERIFICATION_FAILED",
      "MERGE_INPROGRESS",
      "VIDEO_ID_SUBMITTED",
      "VIDEO_ID_LAMBDA_VERIFICATION_FAILED",
      "VIDEO_ID_LAMBDA_VERIFICATION_SUCCESS",
    ];

    if (excludedStatuses.includes(formValues?.contentUploadStatus)) return false;

    // Check expiry date (UTC-normalized): block strictly past dates; allow today/future
    if (
      formValues?.videoIdSubmissionExpiredTime &&
      !isTodayOrFuture(formValues.videoIdSubmissionExpiredTime)
    ) {
      return false;
    }

    return true;
  })();

  // const platformBasedAccess = formValues?.platform === "YOUTUBE" ? getUserInfoReducerData?.channelAccessType === "READ_ONLY" : formValues.platform === "INSTAGRAM" ? getUserInfoReducerData?.channelAccessTypeInstagram === "READ_ONLY" : false


  useEffect(() => {
    if (campId && Array.isArray(getCampaignListFilterData)) {
      const filteredCampaign = getCampaignListFilterData.find(
        (camp) => String(camp.campaignId) === String(campId)
      );
      if (filteredCampaign) {
        setFormValues((prev) => ({
          ...prev,
          ...filteredCampaign,
        }));
      }
    }
  }, [campId, getCampaignListFilterData]);

  useEffect(() => {
    if (campId) {
      dispatch(getCampaignListWithFilter({
        "campaignType": null,
        "startDate": null,
        "endDate": null,
        "status": "ALL"
      }, (status, response, message) => {
        console.log("for Campaign list status, response, message", status, response, message)
        if (status === 200) {
          const filteredCampaign = response.find(
            (camp) => String(camp.campaignId) === String(campId)
          );
          if (filteredCampaign) {
            setFormValues((prev) => ({
              ...prev,
              ...filteredCampaign,
            }));
          }
        }
      }));
    }
  }, []);


  useEffect(() => {
    if (location.state?.campaign) {
      setFormValues(location.state.campaign);
      dispatch(
        getOptedCampaignsDetailsByInfluencer(
          { campaignId: location.state?.campaign.campaignId },
          (status, response, message) => {
            console.log(
              "for Campaign detail status, response, message",
              status,
              response,
              message
            );
            if (status === 200) {
              setFormValues((prev) => ({
                ...prev,
                channelName: response.channelName,
                view: response.views,
                publishedDateTime: response.publishedDateTime
                  ? moment
                    .utc(response.publishedDateTime.split("+")[0])
                    .local()
                    .format("DD-MM-YYYY hh:mm A")
                  : "",
                // // Added: Pre-fill BGC fields
                videoTitle: response.videoTitle || (prev.campaignType === "BGC" ? prev.title : ""),
                videoDescription: response.videoDescription || (prev.campaignType === "BGC" ? prev.description : ""),
              }));
            }
          }
        )
      );
    }
  }, [location.state]);

  const navigateToUpload = () => {
    navigate("/influencer/campaigns/upload", {
      state: {
        campaign: formValues,
      },
    });
  };

  const optClickFucntion = (e) => {
    e.preventDefault();

    dispatch(setIsMergePopupActive(false));
    dispatch(setStreamVideoResponse({}));
    dispatch(setOptAndSubmitContentResponse({}));

    if (formValues.campaignType == "UGC") {
      dispatch(
        optUGCCampaign(
          { campaignId: formValues.campaignId },
          (status, response, message) => {
            // console.log("data" + message);
            if (status === 200) {
              // Toast(message,'success')
              setUgcSuccessPopup(true);
            } else if (status === 202) {
              navigateToUpload();
            } else {
              Toast(message, "error");
            }
          }
        )
      );
    } else if (isBgcFullAccess) {
      // BGC + FULL_ACCESS: direct publish confirmation
      setShowBgcConfirmPopup(true);
    } else if (isBgcReadOnly) {
      // BGC + READ_ONLY: assign campaign with 48-hr deadline, stay on details page
      setShowBgcReadOnlyConfirmPopup(true);
    } else {
      navigateToUpload();
    }
  };

  const downloadContent = () => {
    dispatch(
      viewUGCContentforInfluencer(
        { campaignId: formValues.campaignId },
        (status, response, message) => {
          // console.log("data" + message);
          if (status === 200) {
            let url = response;
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = "file.png"; // Specify a filename
            anchor.click();
          }
        }
      )
    );
  };

  const handleDownloadContentForManualUpload = () => {
    dispatch(
      downloadContentForManualUpload(
        { campaignId: formValues.campaignId },
        (status, response, message) => {
          if (status == 200) {
            const link = document.createElement('a');
            link.href = response;
            link.target = '_blank';
            link.download = '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            Toast(message, "info");
          }
        }
      )
    );
  };

  return (
    <>
      <div className="w-full h-full flex flex-col justify-start bg-[#EDEEF1]">
        <div className="w-full h-full flex flex-col bg-[#F2F3F7]">
          <Breadcrumbs
            breadcrumbs={[
              { label: "Home", href: "/" },
              { label: "My Campaigns", href: "/influencer/campaigns" },
              {
                label: "Campaigns Details",
                href: "/influencer/campaigns/details",
              },
            ]}
          />
          <form className="w-full h-full p-8 shadow-md space-y-4 mt-5 overflow-scroll px-[4rem]">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                  Campaign Name
                </label>
                <input
                  readOnly
                  type="text"
                  name="name"
                  value={formValues.name}
                  placeholder="Enter campaign name"
                  className="w-3/4 h-[4.8rem] border border-gray-300 inter-font font-[400] rounded-md p-[1.1rem] text-[1.6rem] focus:outline-none focus:ring focus:ring-green-400"
                />
              </div>
              <div>
                <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                  Purpose of the Campaign
                </label>
                <input
                  readOnly
                  type="text"
                  name="purpose"
                  value={formValues.purpose}
                  placeholder="Enter purpose"
                  className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                />
              </div>
              <div>
                <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                  Social Media Platform
                </label>
                <input
                  readOnly
                  type="text"
                  name="platform"
                  value={formValues.platform}
                  placeholder="e.g., YouTube"
                  className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                />
              </div>
              <div>
                <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                  Campaign Type
                </label>
                <input
                  readOnly
                  type="text"
                  name="campaignType"
                  value={formValues.campaignType}
                  placeholder="e.g., Video"
                  className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                />
              </div>
              <div>
                <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                  Max View Allowed
                </label>
                <input
                  readOnly
                  type="text"
                  name="campaignType"
                  value={formValues.maxViewCapacity}
                  placeholder=""
                  className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                />
              </div>
              <div>
                <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                  Start Date
                </label>
                <input
                  readOnly
                  type="date"
                  name="startDate"
                  value={formValues.startDate}
                  className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                />
              </div>
              <div>
                <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                  End Date
                </label>
                <input
                  readOnly
                  type="date"
                  name="endDate"
                  value={formValues.endDate}
                  className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                />
              </div>
              {formValues?.campaignType === "BGC" && (
                <>
                  <div>
                    <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                      Title
                    </label>
                    <input
                      readOnly
                      type="text"
                      name="title"
                      value={formValues.title || "--"}
                      placeholder="Brand provided title"
                      className="w-3/4 h-[4.8rem] border border-gray-300 inter-font font-[400] rounded-md p-[1.1rem] text-[1.6rem] focus:outline-none focus:ring focus:ring-green-400"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                      Description
                    </label>
                    <textarea
                      readOnly
                      name="description"
                      value={formValues.description || "--"}
                      placeholder="Brand provided description"
                      className="w-3/4 h-[10rem] border border-gray-300 inter-font font-[400] rounded-md p-[1.1rem] text-[1.6rem] focus:outline-none focus:ring focus:ring-green-400"
                    />
                  </div>
                </>
              )}
              {formValues?.status === "OPTED" && (
                <div>
                  <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                    Channel Name
                  </label>
                  <input
                    readOnly
                    type="text"
                    name="channel"
                    value={formValues.channelName || "--"}
                    className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                  />
                </div>
              )}
              {formValues?.status === "OPTED" && (
                <div>
                  <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                    View
                  </label>
                  <input
                    readOnly
                    type="text"
                    name="view"
                    value={formValues.view || "0"}
                    className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                  />
                </div>
              )}
              {formValues?.status === "OPTED" && (
                <div>
                  <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                    Upload Date
                  </label>
                  <input
                    readOnly
                    type="text"
                    name="uploaddate"
                    value={formValues.publishedDateTime || "--"}
                    className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                  />
                </div>
              )}
              {formValues?.status === "OPTED" && formValues.contentUploadStatus && (
                <div>
                  <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                    Content Upload Status
                  </label>
                  <input
                    readOnly
                    type="text"
                    name="uploaddate"
                    value={sanitizeStatus(formValues.contentUploadStatus) || "--"}
                    className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                  />
                </div>
              )}
              {formValues?.status === "OPTED" && formValues.contentUploadStatus === "ADMIN_REJECT_VIDEO_ID" && (
                <div>
                  <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                    Reject Reason
                  </label>
                  <input
                    readOnly
                    type="text"
                    name="uploaddate"
                    value={formValues.videoIdRejectReason || "--"}
                    className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                  />
                </div>
              )}
              {formValues?.status === "OPTED" && formValues.videoIdSubmissionExpiredTime && (
                <div>
                  <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                    Video ID Submission Expired Time
                  </label>
                  <input
                    readOnly
                    type="text"
                    name="uploaddate"
                    value={formValues.videoIdSubmissionExpiredTime ? moment.utc(formValues.videoIdSubmissionExpiredTime.split("+")[0]).local().format("DD-MM-YYYY hh:mm A") : "--"}
                    className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                  />
                </div>
              )}
              {formValues?.campaignType == "UGC" ? (
                <div>
                  <label
                    for="script"
                    className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]"
                  >
                    Script
                  </label>
                  <textarea
                    type="text"
                    value={formValues?.script}
                    placeholder="script"
                    className="w-3/4 h-[4.8rem] border border-gray-300 text-[1.6rem] text-[#111729] inter-font font-[400] rounded-lg p-4 resize-y"
                    maxLength={1000}
                  />
                </div>
              ) : null}
              {formValues?.campaignType == "UGC" ? (
                <div>
                  <label
                    for="dialogue"
                    className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]"
                  >
                    Dialogue
                  </label>
                  <textarea
                    type="text"
                    value={formValues?.dialogue}
                    placeholder="dialogue"
                    className="w-3/4 h-[4.8rem] border border-gray-300 text-[1.6rem] text-[#111729] inter-font font-[400] rounded-lg p-4 resize-y"
                    maxLength={1000}
                  />
                </div>
              ) : null}
              {formValues?.campaignType == "UGC" ? (
                <div>
                  <label
                    for="properties"
                    className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]"
                  >
                    Other Properites
                  </label>
                  <textarea
                    type="text"
                    value={formValues?.otherProperties}
                    placeholder="properties"
                    className="w-3/4 h-[4.8rem] border border-gray-300 text-[1.6rem] text-[#111729] inter-font font-[400] rounded-lg p-4 resize-y"
                    maxLength={1000}
                  />
                </div>
              ) : null}
              {formValues?.campaignType == "UGC" ? (
                <div>
                  <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                    Background Color
                  </label>
                  <div className="flex w-3/4">
                    <input
                      readOnly
                      type="text"
                      name="Color"
                      value={formValues.backgroundColor}
                      className=" w-full mr-5 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                    />
                    <div
                      className=" w-full h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem]"
                      style={{
                        backgroundColor:
                          formValues.backgroundColor || "transparent",
                      }}
                    ></div>
                  </div>
                </div>
              ) : null}
              {formValues?.campaignType == "UGC" ? (
                <div className="">
                  <label className="block text-gray-700 inter-font font-[400] mb-2 text-[1.6rem]">
                    Location Required
                  </label>
                  <input
                    readOnly
                    className="w-3/4 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                    value={formValues?.isLocationRequired ? "Yes" : "No"}
                  />
                </div>
              ) : null}

              {/* Download Reference Video — visible when referenceVideoUpload is set */}
              {formValues?.referenceVideoUpload && (
                <div className="">
                  <button
                    type="button"
                    disabled={isDownloadingReferenceVideo}
                    className={`border border-[#0D9B50] text-white bg-[#0D9B50] px-6 py-4 rounded-[0.8rem] text-[1.6rem] ${isDownloadingReferenceVideo ? 'opacity-60 cursor-not-allowed' : 'hover:scale-95 cursor-pointer'
                      }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setIsDownloadingReferenceVideo(true);
                      dispatch(
                        downloadReferenceVideo(
                          { campaignId: formValues.campaignId },
                          (status, downloadUrl, message) => {
                            setIsDownloadingReferenceVideo(false);
                            if (status === 200 && downloadUrl) {
                              window.open(downloadUrl, '_blank');
                            } else {
                              Toast(message || 'Failed to get download URL', 'error');
                            }
                          }
                        )
                      );
                    }}
                  >
                    {isDownloadingReferenceVideo ? 'Loading...' : 'Download Reference Video'}
                  </button>
                </div>
              )}
            </div>
            {formValues?.status != "OPTED" && !isBgcReadOnly && (
              <div className="flex items-center text-[1.4rem] text-[#111729] inter-font font-[400]">
                <input
                  readOnly
                  type="checkbox"
                  id="termsCheckbox"
                  className="w-[1.4rem] h-[1.4rem] sm:w-[1.6rem] sm:h-[1.6rem]"
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
                <label htmlFor="termsCheckbox" className="ml-3">
                  I agree to the{" "}
                  <a
                    href="https://terms.paidpromo.ai/influencer_campaign_terms.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#007BFF] underline"
                  >
                    Terms & Conditions
                  </a>
                </label>
              </div>
            )}
            <div className="flex justify-between">
              <div className="flex space-x-6 py-[3rem]">
                {formValues?.status != "OPTED" && !isBgcReadOnly && (
                  <>
                    <button
                      type="submit"
                      className={`bg-[#0D9B50] text-white text-center px-8 py-4 ${!isChecked || formValues?.status === "OPTED"
                        ? "bg-[#C9C9C9] cursor-not-allowed"
                        : "bg-[#0D9B50] hover:scale-95 cursor-pointer"
                        } rounded-[0.8rem] text-[1.6rem]`}
                      disabled={!isChecked || formValues?.status === "OPTED"}
                      onClick={(e) => {
                        optClickFucntion(e);
                      }}
                    >
                      Opt Campaign
                    </button>
                    <button
                      type="button"
                      onClick={() => navigate("/influencer/campaigns")}
                      className="border border-[#0D9B50] bg-[#ffffff] text-gray-700 px-6 py-4 rounded-[0.8rem] text-[1.6rem]"
                    >
                      {formValues?.status === "OPTED" ? "Back" : "Cancel"}
                    </button>
                  </>
                )}
                {(isBgcReadOnly || (formValues?.status === "OPTED" && platformBasedAccess && formValues.campaignType !== "UGC")) && formValues?.contentUploadStatus !== "MERGE_FAILED" && (
                  <>
                    {isButtonVisible && (
                      <button
                        type="button"
                        className={`bg-[#0D9B50] hover:scale-95 cursor-pointer text-white text-center px-8 py-4 rounded-[0.8rem] text-[1.6rem]`}
                        onClick={() => {
                          setSubmitVideoIdPopup(true);
                          setVideoId("");
                          setVideoIdError("");
                          setSubmitMessage("");
                        }}
                      >
                        {formValues?.contentUploadStatus === "ADMIN_REJECT_VIDEO_ID" ? "Re Submit Video ID" : "Submit Video ID"}
                      </button>
                    )}
                    {/* Non-BGC: download composed content for manual upload */}
                    {formValues.campaignType !== "BGC" && (
                      <button
                        type="button"
                        className={`bg-[#0D9B50] text-white text-center px-8 py-4 rounded-[0.8rem] text-[1.6rem]`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleDownloadContentForManualUpload();
                        }}
                      >
                        Download Content
                      </button>
                    )}
                  </>
                )}
              </div>
              {formValues.campaignType == "UGC" ? (
                <div className="py-[3rem]">
                  <button
                    className="border border-[#0D9B50] text-white bg-[#0D9B50] hover:scale-95 cursor-pointer px-6 py-4 rounded-[0.8rem] text-[1.6rem]"
                    onClick={(e) => {
                      e.preventDefault();
                      downloadContent();
                    }}
                  >
                    Download
                  </button>
                </div>
              ) : null}
              {/* BGC download button: always visible when campaignType is BGC */}
              {formValues.campaignType === "BGC" && (
                <div className="py-[3rem]">
                  <button
                    className={`border border-[#0D9B50] text-white bg-[#0D9B50] hover:scale-95 cursor-pointer px-6 py-4 rounded-[0.8rem] text-[1.6rem] ${!formValues.mediaFileLink ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    disabled={!formValues.mediaFileLink}
                    onClick={(e) => {
                      e.preventDefault();
                      // BGC download button: reuse logic from UGC (viewUGCContentforInfluencer)
                      downloadContent();
                    }}
                  >
                    Download Brand Content to Publish
                  </button>
                </div>
              )}

            </div>
            {/* Description Link */}
            {/* {formValues?.descriptionLink && (
              <div className="flex flex-wrap items-center gap-4 px-[4rem] pb-[2rem]">
                <span className="text-[1.6rem] text-gray-700 inter-font font-[500]">Description Link:</span>
                <a
                  href={formValues.descriptionLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[1.6rem] text-[#007BFF] underline inter-font font-[400] break-all"
                >
                  {formValues.descriptionLink}
                </a>
              </div>
            )} */}

          </form>
        </div>
        <Footer />
      </div>
      <Popup
        isOpen={ugcSuccessPopup}
        onClose={() => setUgcSuccessPopup(false)}
        title={"Message"}
        canDismiss={false}
        icon={
          <GiSandsOfTime color="#FFAF45" size={110} className="my-[5rem]" />
        }
        content={
          <p className="text-[1.6rem] w-[80%] mx-auto text-center">
            {optUGCCampaignReducer?.message}
          </p>
        }
        size="sm"
        primaryButton={{
          text: "Done",
          onClick: () => {
            setUgcSuccessPopup(false);
            if (isBgcReadOnly) {
              // BGC + READ_ONLY: stay on this page — status already set to "OPTED",
              // so Submit Video ID / Download Content buttons are already visible.
              // No navigation needed.
            } else {
              navigate("/influencer/campaigns/upload", {
                state: { campaign: formValues },
              });
            }
          },
        }}
      />
      <Popup
        isOpen={submitVideoIdPopup}
        onClose={() => !isSubmitting && setSubmitVideoIdPopup(false)} // Modified: Prevent programmatic close
        title={`${platformDisplayName} ${formValues?.platform === "YOUTUBE" ? "Video" : "Reel"} ID`}
        canDismiss={!isSubmitting} // Modified: Disable Close (X) icon and escape key during submission
        icon={<BsCollectionPlayFill color="#16a34a" size={80} className="my-4" />}
        content={
          <div>
            <input
              type="text"
              value={videoId}
              onChange={(e) => {
                setVideoId(e.target.value);
                if (videoIdError) {
                  setVideoIdError("");
                }
              }}
              placeholder={`Enter ${platformDisplayName} ${formValues?.platform === "YOUTUBE" ? "Video" : "Reel"} ID or URL`}
              className="w-full h-[4.8rem] border border-gray-300 rounded-md p-4 text-start text-[1.6rem] focus:outline-none focus:ring focus:ring-green-400"
            />
            {videoIdError && <p className="text-red-500 text-[1.4rem] mt-2">{videoIdError}</p>}
          </div>
        }
        size="sm"
        primaryButton={{
          text: isSubmitting ? "Submitting..." : "Submit",
          onClick: () => {
            if (!videoId.trim()) {
              setVideoIdError(`Please enter a ${formValues?.platform === "YOUTUBE" ? "Video" : "Reel"} ID`);
              errorTimeoutRef.current = setTimeout(() => setVideoIdError(""), 5000);
              return;
            }
            setIsSubmitting(true);
            const payload = {
              campaignId: formValues.campaignId,
              videoId: videoId,
            };
            dispatch(
              optAndSubmitContentLink(payload, (status, response, message) => {
                setSubmitMessage(message);
                setIsSubmitting(false);
                setSubmitVideoIdPopup(false);
                if (status === 200) {
                  setShowSuccessPopup(true);
                  setVideoId("");
                } else {
                  setShowFailurePopup(true);
                }
              })
            );
          },
          className: "bg-[#16a34a] hover:bg-[#15803d]",
          disabled: isSubmitting,
        }}
        secondaryButton={{
          text: "Cancel",
          onClick: () => setSubmitVideoIdPopup(false),
          className: "bg-gray-200 text-gray-800 hover:bg-gray-300",
          disabled: isSubmitting, // Modified: Disable Cancel button
        }}
      />
      {showSuccessPopup && (
        <Popup
          isOpen={showSuccessPopup}
          onClose={() => setShowSuccessPopup(false)}
          icon={<IoIosCheckmarkCircle color="#16a34a" size={80} className="my-4" />}
          content={
            <p className="text-center text-[1.6rem] text-gray-600">
              {submitMessage || 'Your video ID is submitted. We are validating it and will inform you.'}
            </p>
          }
          size="sm"
          primaryButton={{
            text: "Done",
            onClick: () => { setShowSuccessPopup(false); navigate("/influencer/campaigns"); },
            className: "bg-[#16a34a] hover:bg-[#15803d]",
          }}
        />
      )}
      {showFailurePopup && (
        <Popup
          isOpen={showFailurePopup}
          onClose={() => setShowFailurePopup(false)}
          icon={<IoIosCloseCircle color="#ef4444" size={80} className="my-4" />}
          content={
            <p className="text-center text-[1.6rem] text-gray-600">
              {submitMessage || 'Error: Unable to validate your video ID at the moment. Please try again later'}
            </p>
          }
          size="sm"
          primaryButton={{
            text: "Try Again",
            onClick: () => {
              setVideoId("");
              setVideoIdError("");
              setIsSubmitting(false);
              setSubmitMessage("");
              setShowFailurePopup(false);
              setSubmitVideoIdPopup(true);
            },
            className: "bg-[#ef4444] hover:bg-[#dc2626]",
          }}
          secondaryButton={{
            text: "Cancel",
            onClick: () => setShowFailurePopup(false),
            className: "bg-gray-200 text-gray-800 hover:bg-gray-300",
          }}
        />
      )}
      <Popup
        isOpen={showBgcConfirmPopup}
        onClose={() => setShowBgcConfirmPopup(false)}
        title="Direct Brand Content Posting"
        canDismiss
        icon={<FaCircleExclamation color="#0D9B50" size={80} className="my-4" />}
        content={
          <p className="text-[1.6rem] w-[85%] mx-auto text-center">
            This brand content will be directly posted to your{" "}
            <strong>{platformDisplayName}</strong> channel using your full access
            permissions.
            <br /><br />
            The campaign title and description will be used for publishing.
            <br /><br />
            Do you want to continue?
          </p>
        }
        size="sm"
        primaryButton={{
          text: isBgcSubmitting ? "Submitting..." : "OK",
          disabled: isBgcSubmitting,
          onClick: () => {
            if (!formValues.mediaFileLink) {
              Toast("Brand content not available for this campaign.", "error");
              return;
            }
            setIsBgcSubmitting(true);
            dispatch(
              optAndSubmitContent(
                {
                  campaignId: formValues.campaignId,
                  uploadFileS3Path: formValues.mediaFileLink,
                },
                (status, response, message) => {
                  setIsBgcSubmitting(false);
                  setShowBgcConfirmPopup(false);
                  if (status === 200 || status === 202) {
                    setSubmitMessage(message);
                    setOptResponse(response);
                    setIsPublishPopupOpen(true);
                  } else {
                    setSubmitMessage(message);
                    setShowFailurePopup(true);
                  }
                }
              )
            );
          },
        }}
        secondaryButton={{
          text: "Cancel",
          disabled: isBgcSubmitting,
          onClick: () => setShowBgcConfirmPopup(false),
        }}
      />
      {/* ── BGC + READ_ONLY: Step 1 confirmation popup ─────────────────── */}
      <Popup
        isOpen={showBgcReadOnlyConfirmPopup}
        onClose={() => setShowBgcReadOnlyConfirmPopup(false)}
        title="Campaign Assignment"
        canDismiss
        icon={<GiSandsOfTime color="#FFAF45" size={100} className="my-[3rem]" />}
        content={
          <p className="text-[1.6rem] w-[85%] mx-auto text-center">
            The campaign will be assigned to you. Please upload the required
            content within <strong>48 hours</strong> to complete the campaign
            opt-in.
            <br /><br />
            Click <strong>OK</strong> to confirm your participation.
          </p>
        }
        size="sm"
        primaryButton={{
          text: isBgcReadOnlySubmitting ? "Assigning..." : "OK",
          disabled: isBgcReadOnlySubmitting,
          onClick: () => {
            setIsBgcReadOnlySubmitting(true);
            dispatch(
              optUGCCampaign(
                { campaignId: formValues.campaignId },
                (status, response, message) => {
                  setIsBgcReadOnlySubmitting(false);
                  setShowBgcReadOnlyConfirmPopup(false);
                  if (status === 200) {
                    // Update status in-place so Opt Campaign button disappears
                    // and Submit Video ID / Download Content buttons appear immediately
                    setFormValues((prev) => ({ ...prev, status: "OPTED" }));
                    // Step 2: reuse existing ugcSuccessPopup — shows deadline from backend message
                    setUgcSuccessPopup(true);
                  } else {
                    Toast(message || "Failed to assign campaign. Please try again.", "error");
                  }
                }
              )
            );
          },
        }}
        secondaryButton={{
          text: "Cancel",
          disabled: isBgcReadOnlySubmitting,
          onClick: () => setShowBgcReadOnlyConfirmPopup(false),
        }}
      />
      <Popup
        isOpen={isPublishPopupOpen}
        onClose={() => setIsPublishPopupOpen(false)}
        title={!isScheduleMode ? "Publish It" : "Schedule It"}
        canDismiss
        content={
          <div className="text-[1.6rem] mt-12">
            <form className="space-y-4">
              <div className="flex justify-end mb-2">
                <button
                  type="button"
                  onClick={() => setIsScheduleMode(!isScheduleMode)}
                  className="text-[1.4rem] text-[#0D9B50] font-medium hover:underline"
                >
                  {isScheduleMode ? "Back to Publish Now" : "Schedule for Later"}
                </button>
              </div>
              <div>
                <label htmlFor="title" className="text-[#202224] text-[1.5rem]">
                  Title<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  readOnly
                  value={formValues.videoTitle || formValues.title || ""}
                  className="w-full bg-[#F7FBFF] h-20 border border-gray-300 rounded-2xl px-4 py-2 focus:outline-none cursor-not-allowed"
                />
              </div>
              <div>
                <label htmlFor="description" className="text-[#202224] text-[1.5rem]">
                  Description<span className="text-red-500">*</span>
                </label>
                <input
                  id="description"
                  readOnly
                  value={formValues.videoDescription || formValues.description || ""}
                  className="w-full bg-[#F7FBFF] h-20 border border-gray-300 rounded-2xl px-4 py-2 focus:outline-none cursor-not-allowed"
                />
              </div>
              {formValues.platform === "YOUTUBE" && (
                <div className="flex flex-col">
                  <label className=" ">
                    <input
                      type="radio"
                      name="madeForKidsOption"
                      checked={selectedKids === true}
                      onChange={() => setSelectedKids(true)}
                      className="w-5 h-5 "
                    />
                    <span className="text-[#202224] text-[1.5rem] ml-3">
                      Yes, it's made for kids
                    </span>
                  </label>

                  <label className=" mt-2 ">
                    <input
                      type="radio"
                      name="madeForKidsOption"
                      checked={selectedKids === false}
                      onChange={() => setSelectedKids(false)}
                      className="w-5 h-5 "
                    />
                    <span className="text-[#202224] text-[1.5rem] ml-3">
                      No, it's not made for kids
                    </span>
                  </label>
                </div>
              )}

              {isScheduleMode && (
                <div className="relative w-full ">
                  <label htmlFor="datetime" className="text-[#202224] text-[1.5rem]">
                    Add Schedule<span className="text-red-500">*</span>
                  </label>
                  <div className="w-full bg-[#F7FBFF] border border-gray-300 rounded-2xl">
                    <input
                      type="datetime-local"
                      id="datetime"
                      min={(() => {
                        const now = new Date();
                        const tzoffset = now.getTimezoneOffset() * 60000;
                        return new Date(now.getTime() - tzoffset).toISOString().slice(0, 16);
                      })()}
                      placeholder="Enter Schedule here"
                      className="w-full h-20 bg-[#F7FBFF] px-4 py-2 focus:outline-none"
                      value={scheduleTime}
                      onChange={(e) => {
                        const selectedTime = new Date(e.target.value);
                        const currentTime = new Date();
                        if (selectedTime < currentTime) {
                          Toast("Scheduled time must be in the future.", "error");
                        } else {
                          setScheduleTime(e.target.value);
                        }
                      }}
                    />
                    <img
                      src={MyCampaignsImg.calendarIcon}
                      alt="Calendar Icon"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 mt-4 w-10 h-10"
                      onKeyDown={(e) => e.preventDefault()}
                      onClick={() => {
                        const inputDateElement = document.getElementById("datetime");
                        inputDateElement.showPicker();
                      }}
                    />
                  </div>
                </div>
              )}
            </form>
          </div>
        }
        size="sm"
        primaryButton={{
          text: loadingPublish ? (
            <div className="flex items-center justify-center">
              <Oval visible={true} height="25" width="25" color="#000000" ariaLabel="oval-loading" />
            </div>
          ) : !isScheduleMode ? (
            "Upload Now"
          ) : (
            "Schedule Now"
          ),
          disabled: loadingPublish || (isScheduleMode && !scheduleTime),
          onClick: () => {
            if (isScheduleMode) {
              if (!scheduleTime) {
                Toast("Please select a schedule time", "error");
                return;
              }
              if (new Date(scheduleTime) < new Date()) {
                Toast("Scheduled time must be in the future.", "error");
                return;
              }
            }
            setLoadingPublish(true);
            const payload = {
              contentId: optResponse?.contentId,
              title: formValues.videoTitle || formValues.title,
              description: formValues.videoDescription || formValues.description,
              isPublishNow: !isScheduleMode,
              scheduleDateTime: isScheduleMode ? moment(scheduleTime).format("YYYY-MM-DD HH:mm:ss") : "",
              madeForKids: selectedKids,
            };
            dispatch(
              publishVideoOnYoutube(payload, (status, response, message) => {
                setLoadingPublish(false);
                setIsPublishPopupOpen(false);
                setSubmitMessage(message);
                if (status === 200) {
                  setShowSuccessPopup(true);
                } else {
                  setShowFailurePopup(true);
                }
              })
            );
          },
        }}
        secondaryButton={{
          text: "Cancel",
          disabled: loadingPublish,
          onClick: () => setIsPublishPopupOpen(false),
          className: "bg-gray-200 text-gray-800 hover:bg-gray-300",
        }}
      />
    </>
  );
};

export default CampaignsDetails;
